import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-agility-risk-setup',
  templateUrl: './agility-risk-setup.component.html',
  styleUrls: ['./agility-risk-setup.component.scss']
})
export class AgilityRiskSetupComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
    console.log('todo');
  }

}
